import api from './api';
import { handleApiError } from '../utils/apiErrors';

export const productService = {
    getAllProducts: async () => {
        try {
            const response = await api.get('/products');
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    getProductById: async (id) => {
        try {
            const response = await api.get(`/products/${id}`);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    // Admin features (if needed later)
    createProduct: async (data) => {
        try {
            const response = await api.post('/products', data);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    updateProduct: async (id, data) => {
        try {
            const response = await api.put(`/products/${id}`, data);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    deleteProduct: async (id) => {
        try {
            const response = await api.delete(`/products/${id}`);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    }
};
